import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import ReactConfirmAlert, { confirmAlert } from "react-confirm-alert";
import { updateSelectedFeature, updateAdvertisement } from "GeneralTabAction";
import { NEW_IMAGE_PATH, DEVELOPMENT_TYPE } from "Constants";
import { Row, Col, Button } from "react-bootstrap";
import { updateUnsavedChanges } from "DashboardMenuAction";
import AppIcons from "AppIcons";
import LocaleStrings from "Languages";

class ListItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      buttonText: { key: "add", title: LocaleStrings.add },
    };
  }

  selectFeature() {
    let that = this;

    if (
      this.props.feature.bsClass == "sponsor" &&
      this.props.feature.isenabled == true
    ) {
      var internalscreen = "sponsor";
      var isenabled = false;
      confirmAlert({
        title: LocaleStrings.feature_confirmAlert_removingSponsor_title,
        message: LocaleStrings.feature_confirmAlert_removingSponsor_message,
        confirmLabel: LocaleStrings.button_ok,
        cancelLabel: LocaleStrings.button_cancel,
        buttons: [
          {
            label: LocaleStrings.button_ok,
            onClick: () => {
              this.props.updateAdvertisement(
                this.props.session,
                internalscreen,
                isenabled
              );
              this.props.feature.isenabled = !this.props.feature.isenabled;
              this.props.updateSelectedFeature(
                this.props.selectedFeatures,
                this.props.feature
              );
              this.props.updateUnsavedChanges();
            },
          },
          {
            label: LocaleStrings.button_cancel,
            onClick: () => {},
          },
        ],
      });
    } else if (
      this.props.feature.bsClass == "sponsor" &&
      this.props.feature.isenabled == false
    ) {
      var internalscreen = "sponsor";
      var isenabled = true;
      confirmAlert({
        title: LocaleStrings.feature_confirmAlert_addSponsor_title,
        message: LocaleStrings.feature_confirmAlert_addSponsor_message,
        confirmLabel: LocaleStrings.button_ok,
        cancelLabel: LocaleStrings.button_cancel,
        buttons: [
          {
            label: LocaleStrings.button_ok,
            onClick: () => {
              this.props.updateAdvertisement(
                this.props.session,
                internalscreen,
                isenabled
              );
              this.props.feature.isenabled = !this.props.feature.isenabled;
              this.props.updateSelectedFeature(
                this.props.selectedFeatures,
                this.props.feature
              );
              this.props.updateUnsavedChanges();
            },
          },
          {
            label: LocaleStrings.button_cancel,
            onClick: () => {},
          },
        ],
      });
    } else if (
      this.props.feature.bsClass == "exhibitor" &&
      this.props.feature.isenabled == true
    ) {
      var internalscreen = "exhibitor";
      var isenabled = false;
      confirmAlert({
        title: LocaleStrings.feature_confirmAlert_removingExhibitor_title,
        message: LocaleStrings.feature_confirmAlert_removingExhibitor_message,
        confirmLabel: LocaleStrings.button_ok,
        cancelLabel: LocaleStrings.button_cancel,
        buttons: [
          {
            label: LocaleStrings.button_ok,
            onClick: () => {
              this.props.updateAdvertisement(
                this.props.session,
                internalscreen,
                isenabled
              );
              this.props.feature.isenabled = !this.props.feature.isenabled;
              this.props.updateSelectedFeature(
                this.props.selectedFeatures,
                this.props.feature
              );
              this.props.updateUnsavedChanges();
            },
          },
          {
            label: LocaleStrings.button_cancel,
            onClick: () => {},
          },
        ],
      });
    } else if (
      this.props.feature.bsClass == "exhibitor" &&
      this.props.feature.isenabled == false
    ) {
      var internalscreen = "exhibitor";
      var isenabled = true;
      confirmAlert({
        title: LocaleStrings.feature_confirmAlert_addExhibitor_title,
        message: LocaleStrings.feature_confirmAlert_addExhibitor_message,
        confirmLabel: LocaleStrings.button_ok,
        cancelLabel: LocaleStrings.button_cancel,
        buttons: [
          {
            label: LocaleStrings.button_ok,
            onClick: () => {
              this.props.updateAdvertisement(
                this.props.session,
                internalscreen,
                isenabled
              );
              this.props.feature.isenabled = !this.props.feature.isenabled;
              this.props.updateSelectedFeature(
                this.props.selectedFeatures,
                this.props.feature
              );
              this.props.updateUnsavedChanges();
            },
          },
          {
            label: LocaleStrings.button_cancel,
            onClick: () => {},
          },
        ],
      });
    } else {
      this.props.feature.isenabled = !this.props.feature.isenabled;
      this.props.updateSelectedFeature(
        this.props.selectedFeatures,
        this.props.feature
      );
      this.props.updateUnsavedChanges();
    }
    // Attendee auto disable on disbale of message hide.
    // if (
    //   this.props.feature.bsClass === "message" &&
    //   this.props.feature.isenabled
    // ) {

    //   confirmAlert({
    //     title: LocaleStrings.features_users_modules_confirmation_title_alert,
    //     message:
    //       LocaleStrings.features_users_feature_confirmation_text_continue,
    //     confirmLabel: LocaleStrings.button_ok,
    //     cancelLabel: LocaleStrings.button_cancel,
    //     onConfirm: () => {
    //       that.props.feature.isenabled = !that.props.feature.isenabled;
    //       that.props.updateSelectedFeature(
    //         that.props.selectedFeatures,
    //         that.props.feature
    //       );
    //       that.props.updateUnsavedChanges();

    //       // Disabling attendee also if user get disabled
    //       if (DEVELOPMENT_TYPE === "eventify") {
    //         that.props.attendeeFeature[0].isenabled =
    //           that.props.feature.isenabled;
    //         that.props.updateSelectedFeature(
    //           that.props.selectedFeatures,
    //           that.props.attendeeFeature[0]
    //         );
    //       }
    //       // debugger;
    //     },
    //     onCancel: () => {},
    //   });
    // } else {
    // this.props.feature.isenabled = !this.props.feature.isenabled;
    // this.props.updateSelectedFeature(
    //   this.props.selectedFeatures,
    //   this.props.feature
    // );
    // this.props.updateUnsavedChanges();
    // }
  }

  mouseOver() {
    var isSelected = this.props.feature.isenabled ? true : false;

    if (isSelected) {
      this.setState({
        buttonText: { key: "remove", title: LocaleStrings.remove },
      });
    }
  }

  mouseOut() {
    var isSelected = this.props.feature.isenabled ? true : false;

    if (isSelected) {
      this.setState({
        buttonText: { key: "added", title: LocaleStrings.added },
      });
    }
  }

  render() {
    let { userModule, feature } = this.props;
    let { buttonText } = this.state;
    var title = buttonText.title;
    var isSelected = feature.isenabled ? true : false;
    var iconUrl = `${NEW_IMAGE_PATH}features/features_${feature.bsClass}.png`;
    var iconClass = "";

    if (isSelected) {
      iconClass = "feature-button-selected";
      if (buttonText.key === "add") title = LocaleStrings.added;
    } else {
      iconClass = "feature-button";
      // if (buttonText.key === "remove")
      title = LocaleStrings.add;
    }

    let extraLi = feature.label !== "extra_blank" ? "" : "extra-li";

    return (
      <li className={extraLi}>
        {feature.label !== "extra_blank" ? (
          <Row className="h-full">
            <Col md={2} sm={2} xs={2} className="feature-image">
              {/* <img className="feature-icon" src={iconUrl} /> */}
              <div className={`feature-icon`}>{AppIcons[feature.bsClass]}</div>
            </Col>
            <Col md={6} sm={6} xs={6} className="feature-content">
              <div className="feature-title">{feature.label}</div>
              <div className="feature-description">{feature.description}</div>
            </Col>
            {
              // commented as per new requirement
              // feature.bsClass == "about" ? (
              //   <Col md={4} className="feature-actions">
              //     <div className="btn feature-button-always-selected">
              //       {LocaleStrings.added}
              //     </div>
              //   </Col>
              // ) :
              (feature.bsClass == "message" ||
                feature.bsClass == "attendee" ||
                feature.bsClass == "social" ||
                feature.bsClass == "survey" ||
                feature.bsClass == "community") &&
              userModule.length > 0 &&
              !userModule[0].isenabled ? (
                // This if condition userd to handle user disable, so message, attendee, social, survey and community will also disable
                <OverlayTrigger
                  key={feature.bsClass}
                  placement="top"
                  overlay={
                    <Tooltip id={`tooltip-${feature.bsClass}`}>
                      {LocaleStrings.features_text_add_user_first}
                    </Tooltip>
                  }>
                  <Col md={4} sm={2} xs={2} className="feature-actions">
                    <Button
                      className={iconClass}
                      onMouseOut={this.mouseOut.bind(this)}
                      onMouseOver={this.mouseOver.bind(this)}
                      onClick={this.selectFeature.bind(this)}>
                      {LocaleStrings.add}
                    </Button>
                  </Col>
                </OverlayTrigger>
              ) : (
                <Col md={4} sm={2} xs={2} className="feature-actions">
                  <Button
                    className={iconClass}
                    onMouseOut={this.mouseOut.bind(this)}
                    onMouseOver={this.mouseOver.bind(this)}
                    onClick={this.selectFeature.bind(this)}>
                    {title}
                  </Button>
                </Col>
              )
            }
          </Row>
        ) : (
          <div></div>
        )}
      </li>
    );
  }
}

function mapStateToProps(state) {
  let userModule = [{ isenabled: false }];
  let messageFeature = [{ isenabled: false }];
  let attendeeFeature = [{ isenabled: false }];

  if (state.selectedFeatures && state.selectedFeatures.length > 0) {
    messageFeature = _.filter(state.selectedFeatures, (obj) => {
      return obj.bsClass == "message";
    });
    attendeeFeature = _.filter(state.selectedFeatures, (obj) => {
      return obj.bsClass == "attendee";
    });
  }

  if (state.actionAppModules && state.actionAppModules.length > 0) {
    userModule = _.filter(state.actionAppModules, (obj) => {
      return obj.bsClass == "users";
    });
  }

  return {
    selectedFeatures: state.selectedFeatures,
    actionAppModules: state.actionAppModules,
    userModule,
    messageFeature,
    attendeeFeature,
    session: state.session,
  };
}

export default connect(mapStateToProps, {
  updateSelectedFeature,
  updateAdvertisement,
  updateUnsavedChanges,
})(ListItem);
